import React, { createContext, useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import {
  statusAllDetails,
  getDownloadExcel,
  getCategoryList,
} from "../../api/Api";
import RouteContents from "../../constants/routesContent.json";

export const StatusAllContext = createContext({});
export const StatusAllContextProvider = ({ children }) => {
  const location = useLocation();
  const [totalPageCount, setTotalPageCount] = useState(
    location?.state?.numPages
  );
  const [currentPage, setCurrentPage] = useState(1);
  const [currentPageCategory, setCurrentPageCategory] = useState(1);
  const [newExcel, setNewExcel] = useState("");
  const [spinnerStatus, setSpinnerStatus] = useState(false);
  const [statusAllData, setStatusAllData] = useState(
    location?.state?.employees
  );
  const [categoryListDropDown, setCategoryListDropDown] = useState([]);
  const [statusAllExcelDownload, setStatusAllExcelDownload] = useState(
    location?.state?.excelFile
  );
  const [showAlert, setShowAlert] = useState(false);
  const [alertMessage, setAlertMessage] = useState("");
  const [statusCode, setStatusCode] = useState(0);
  const [visitorType, setVisitorType] = useState({
    id: "",
    name: "All Categories",
  });
  const navigate = useNavigate();
  const [categoryId ,setCategoryId] = useState("")
  const [spinnerDownloadStatus, setSpinnerDownloadStatus] = useState(false);
  const [catogorySpinner, setCatogorySpinner] = useState(false);
  const goBack = () => {
    navigate(-1);
  };
  const categoryTypeData = async (categoryType) => {
   
  
    setCatogorySpinner(true);
    setCategoryId(categoryType)
  
    try {
      const loadStatusAllData = await statusAllDetails(categoryType, 1);
    
     // setCatogorySpinner(true);
      setStatusAllData(loadStatusAllData?.data?.data?.employees);
      setTotalPageCount(loadStatusAllData?.data?.data?.numPages);
     
    } catch (error) {
      setCatogorySpinner(false);
      console.log("error --->", error);
    }
  finally {
   
   
    setCatogorySpinner(false);
    
  };
  }
  const onPageChange = async (pageNum) => {
    setCurrentPage(pageNum);
    setSpinnerStatus(true);
    try {
      const loadStatusAllData = await statusAllDetails(visitorType.id, pageNum);
     
      setStatusAllData(loadStatusAllData?.data?.data?.employees);
      setTotalPageCount(loadStatusAllData?.data?.data?.numPages);
      setSpinnerStatus(false);
    } catch (error) {
      setSpinnerStatus(false);
      console.log("error --->", error);
    }
  };

  const logout = () => {
    localStorage.removeItem("x-access-token");
    localStorage.removeItem("permissions");
    localStorage.removeItem("remember");
    navigate(RouteContents.LOGIN);
  };

  const callCategoryList = async () => {
    setSpinnerStatus(true)
    try {
      const getData = await getCategoryList();
      if (getData.data.status === 200) {
        setCategoryListDropDown(getData?.data?.data?.categories);
        setSpinnerStatus(false)
      }
    } catch (error) {
      setStatusCode(error?.response?.data?.status);
      if (
        error.response.data.status === 401 ||
        error.response.data.status === 400
      ) {
        const errorMessage = error.response.data.message;
        setShowAlert(true);
        setAlertMessage(error.response.data.message);
      } else {
        setShowAlert(true);
        setAlertMessage("Something went wrong");
      }
    }
  };
  useEffect(() => {
    callCategoryList();
    
  }, [categoryId]);
  const downloadExcelSheet = async () => {
    
    setSpinnerDownloadStatus(true);
    const data = {
      search: "status",
      filter: "all",
      empData: "",
      fromDate: "",
      toDate: "",
      zoneFilter: "",
      categoryFilter: categoryId,
      visitorType:""
    };
   
    try {
      const response = await getDownloadExcel(data);

      if (response.data.status === 200) {
     
        setNewExcel(response?.data?.data?.filename);
       
      }
    } catch (error) {
      
      setStatusCode(error?.response?.data?.status);
      if (error?.response?.data?.status === 400) {
        setShowAlert(true);
        setAlertMessage(error?.response?.data?.message);
      } else if (error?.response?.data?.status === 401) {
        setShowAlert(true);
        setAlertMessage(error?.response?.data?.message);
      } else if (error?.response?.data?.status === 403) {
        setShowAlert(true);
        setAlertMessage(error?.response?.data?.message);
      } else {
        setShowAlert(true);
        setAlertMessage("Something went wrong");
      }
    }finally {
   
 
        setSpinnerDownloadStatus(false);
    
      }
  };

  useEffect(() => {
    downloadExcelSheet();
  }, [categoryId]);

  const providerValue = {
    goBack,
    totalPageCount,
    logout,
    currentPage,
    newExcel,
    statusAllData,
    statusAllExcelDownload,
    onPageChange,
    spinnerStatus,
    setShowAlert,
    showAlert,
    statusCode,
    categoryListDropDown,
    categoryTypeData,
    alertMessage,
    visitorType,
    setCurrentPage,
    setVisitorType,
    categoryId ,setCategoryId,
    spinnerDownloadStatus, setSpinnerDownloadStatus,
    catogorySpinner, setCatogorySpinner
  };

  return (
    <StatusAllContext.Provider value={providerValue}>
      {children}
    </StatusAllContext.Provider>
  );
};
